import {
    apiGetClient,
    apiPostClient,
    apiPutClient,
} from "../../../api/apiSvtAdmin";

import { toast } from "react-toastify";
import i18n from "i18next";
const t = i18n.t.bind(i18n);

export const getAllPICUsers = async () => {
    try {
        const response = await apiGetClient.get("picusers");
        return response.data;
    } catch (error) {
        toast.error(t("fetchPICUsersError"), { position: "top-center" });
        return null;
    }
};

export const createNewPICUser = async (data) => {
    try {
        const response = await apiPostClient.post("picusers", data);
        return response.data;
    } catch (error) {
        let errorData = error.response.data;
        if (errorData?.errors) {
            Object.keys(errorData?.errors).forEach((field) => {
                errorData?.errors[field].forEach((message) => {
                    toast.error(message, { position: "top-center" });
                });
            });
        } else {
            toast.error(error.response?.data?.error, { position: "top-center" });
        }
        return null;
    }
};

export const updatePICUser = async (data, id) => {
    try {
        const response = await apiPutClient.put(`picusers/${id}`, data);
        return response.data;
    } catch (error) {
        let errorData = error.response.data;
        if (errorData?.errors) {
            Object.keys(errorData?.errors).forEach((field) => {
                errorData?.errors[field].forEach((message) => {
                    toast.error(message, { position: "top-center" });
                });
            });
        } else {
            toast.error(error.response.data?.error, { position: "top-center" });
        }
        return null;
    }
};

export const getPICByUserId = async (data) => {
    try {
        const response = await apiGetClient.get(`picusers/${data.userId}`);
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};

export const revokePICUser = async (data) => {
    try {
        const response = await apiGetClient.put(
            `picusers/revoke/${data.userId}/?organizationId=${data.organizationId}&roleId=${data.roleId}`,
            data
        );
        return response.data;
    } catch (error) {
        let errorData = error.response.data;
        if (errorData?.errors) {
            Object.keys(errorData?.errors).forEach((field) => {
                errorData?.errors[field].forEach((message) => {
                    toast.error(message, { position: "top-center" });
                });
            });
        } else {
            toast.error(error.response.data?.error, { position: "top-center" });
        }
        return null;
    }
};

export const getAllSectors = async () => {
    try {
        const response = await apiGetClient.get("foundation/company/sectors");
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};

export const getAllBusinessUnits = async (data) => {
    try {
        const response = await apiGetClient.get(
            `foundation/company/sectors/${data.sectorId}/business-units`
        );
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};

export const getAllSubBusinessUnits = async (data) => {
    try {
        const response = await apiGetClient.get(
            `foundation/company/business-units/${data.buId}/sub-business-units`
        );
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};

export const getAllLegalEntities = async (data) => {
    try {
        const response = await apiPostClient.post(
            "foundation/company/sub-business-units/legal-entities",
            data
        );
        return response.data;
    } catch (error) {
        return null;
    }
};

export const findPICUsers = async (data) => {
    try {
        // const response = await apiGetClient.get(`api/PICUsers?tierId=${data.tierId}&organizationId=${data.organizationId}`);
        const response = await apiGetClient.get(
            `picusers?organizationId=${data.organizationId}`
        );
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};
